import { Buffer } from 'buffer';
(globalThis as typeof globalThis & { Buffer: typeof Buffer }).Buffer = Buffer;

// Initialise i18n before anything else. This is a side-effect import that
// sets up the i18next singleton (language detection + translation resources).
import '@yada/i18n';

// Auto-recover from stale chunks / 404 assets after new deployments
if (typeof window !== 'undefined') {
  window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault();
    const storageKey = 'yada:last_chunk_reload';
    const lastReload = Number(sessionStorage.getItem(storageKey) || 0);
    // Prevent infinite reload loops if asset genuinely missing on server
    if (Date.now() - lastReload > 10000) {
      sessionStorage.setItem(storageKey, String(Date.now()));
      window.location.reload();
    }
  });

  window.addEventListener('error', (event) => {
    const msg = event.message || '';
    if (
      msg.includes('Failed to fetch dynamically imported module') ||
      msg.includes('error loading dynamically imported module') ||
      msg.includes('Importing a module script failed')
    ) {
      const storageKey = 'yada:last_chunk_reload';
      const lastReload = Number(sessionStorage.getItem(storageKey) || 0);
      if (Date.now() - lastReload > 10000) {
        sessionStorage.setItem(storageKey, String(Date.now()));
        window.location.reload();
      }
    }
  });
}

import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './ui/App';
import './ui/base.css';
const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');
const root = createRoot(container);
root.render(<App />);
